<template>
  <div class="container">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <div class="navbar-brand nav-logo" :to="{ name: 'Main_page' }">
      <img :src='"../assets/images/logo.png"' alt="logo">
    </div>
    <b-collapse class="default-nav" is-nav id="nav_collapse">
      <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
        <b-nav-item href="#home">Inicio</b-nav-item>
        <b-nav-item href="#feature">Solução</b-nav-item>
        <b-nav-item href="#screenshot">Sistema</b-nav-item>
        <b-nav-item href="#contact">SEJA UM PARCEIRO</b-nav-item>
        <b-nav-item href="https://portaldoparceiro.com/">PORTAL DO PARCEIRO</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </div>
</template>
<script>
export default {
  name: 'Navbar'
}
</script>
<style scoped>
.nav-logo {
  display: flex;
  align-items: flex-end;
}

.nav-logo img {
  width: 170px;
  margin-right: 10px;
  position: absolute;
  top: 50px;
}

.nav-logo span {
  line-height: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue